import React from "react";

export default function Principal() {
  const user = JSON.parse(localStorage.getItem("user"));

  return (
    <div style={{ padding: 40 }}>
      <h1>Pantalla Principal</h1>

      {user && (
        <p>
          Bienvenido, <strong>{user.persona_nombre || user.usuario}</strong>  
          <br />
          Rol: <strong>{user.rol_nombre}</strong>
        </p>
      )}

      <button
        onClick={() => {
          localStorage.removeItem("user");
          window.location.href = "/";
        }}
      >
        Cerrar sesión
      </button>
    </div>
  );
}
